import { render, staticRenderFns } from "./CustomUnits.vue?vue&type=template&id=5d122d20&scoped=true&"
import script from "./CustomUnits.vue?vue&type=script&lang=js&"
export * from "./CustomUnits.vue?vue&type=script&lang=js&"
import style0 from "./CustomUnits.vue?vue&type=style&index=0&id=5d122d20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d122d20",
  null
  
)

export default component.exports